'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getFeatureConfig: ()=>getFeatureConfig
});
const useSeti_js_namespaceObject = require("../utils/useSeti.js");
const getFeatureConfig = (viewType, isChatbotOpened)=>{
    const featureConfig = {
        LANDING: {
            isCaresSurveyEligible: false,
            isSurveyEligible: true,
            setiValues: {
                enableMyTripsSignIn: true,
                enableVoice: true,
                isCustomVoice: true,
                enableVoiceTooltip: true,
                isRealtime: true,
                shouldDisplayCheckoutButton: true,
                shouldDisplaySurvey: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_SURVEY_CHAT_HISTORY',
                    shouldFireImpression: false
                })),
                shouldShowHotelPricePin: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_MAP_HOTEL_PRICING',
                    shouldFireImpression: false
                })),
                shouldEnableSelectTrip: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'CHATBOT_TRIP_CARDS_SELECT_TRIP',
                    shouldFireImpression: false
                })),
                shouldDisplayPersonalizedGreeting: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_PERSONALIZATION_GREETING',
                    shouldFireImpression: false
                })),
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                })),
                shouldDisplayGenHotelFeature: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        PORTAL: {
            isCaresSurveyEligible: false,
            isSurveyEligible: true,
            setiValues: {
                enableMyTripsSignIn: true,
                enableVoice: true,
                enableVoiceTooltip: true,
                isRealtime: true,
                isCustomVoice: true,
                shouldDisplayCheckoutButton: true,
                shouldDisplaySurvey: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_SURVEY_CHAT_HISTORY',
                    shouldFireImpression: false
                })),
                shouldEnableSelectTrip: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'CHATBOT_TRIP_CARDS_SELECT_TRIP',
                    shouldFireImpression: false
                })),
                shouldDisplayGenHotelFeature: true,
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                })),
                shouldShowHotelPricePin: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_MAP_HOTEL_PRICING',
                    shouldFireImpression: false
                }))
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        STAYDETAILS: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        STAYLISTINGS: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        ITINERARY: {
            isCaresSurveyEligible: true,
            isSurveyEligible: true,
            setiValues: {
                enableVoice: true,
                enableVoiceTooltip: true,
                isCaresSurveyEnabled: true,
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true,
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                }))
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        FLYDETAILS: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: false,
                isCustomVoice: false,
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                }))
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        FLYLISTINGS: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: false,
                isCustomVoice: false,
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                }))
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        DRIVE: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true,
                shouldEnableTextAnimation: Boolean((0, useSeti_js_namespaceObject.useSeti)({
                    testName: 'PENNY_TEXT_FADE_IN_ANIMATION',
                    shouldFireImpression: true
                }))
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        PACKAGE: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        CHECKOUT: {
            isCaresSurveyEligible: false,
            isSurveyEligible: false,
            setiValues: {
                isRealtime: false,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        }
    };
    const config = featureConfig[viewType];
    if (!config) throw new Error(`No feature configuration found for viewType: ${viewType}. Add configuration to featureConfig object in /react-components/penny-chat-bot/src/config/featureConfig.ts. `);
    return config;
};
exports.getFeatureConfig = __webpack_exports__.getFeatureConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getFeatureConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
